import { Box } from "@mui/system";
import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { Button, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import farmStoriesVideo from "../assets/farmstoriesModal.mp4";
const style = {
  BannerContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "900px",
  },
  imgContainer: {
    width: "100%",
    height: "100%",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    filter: "brightness(90%) grayscale(10%)",
  },
  overLayText: {
    position: "absolute",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // Ensures center alignment
    textAlign: "center",
    color: "#FFFFFF",
    top: "50%",
    transform: "translateY(-50%)", 
  },
  page: {
    fontFamily: "'ZapfHumnst BT', sans-serif",
    fontSize: {
      xs: "12px",
      sm: "16px",
    },
    fontWeight: "400",
    lineHeight: {
      xs: "13.62px",
      sm: "19.8px",
    },
    letterSpacing: "0.05em",
  },
  Quote: {
    fontFamily: "'ZapfHumnst BT', sans-serif",
    fontSize: {
      xs: "24px",
      sm: "48px",
    },
    lineHeight: {
      xs: "29.71px",
      sm: "59.41px",
    },
    fontWeight: "400",
    letterSpacing: "0.05em",
  },
  Quote2: {
    fontFamily: "'ZapfHumnst BT', sans-serif",
    fontSize: {
      xs: "24px",
      sm: "48px",
    },
    lineHeight: {
      xs: "15.62px",
      sm: "30.8px",
    },
    fontWeight: "400",
    letterSpacing: "0.05em",
    marginTop:"2%"
  },
};

const TopBannerSection = ({
  pageName,
  Quote,
  Image,
  description,
  watchFlimBtn = false,
}) => {
  const [iconColor, setIconColor] = useState("white");
  const [open, setOpen] = useState(false);

  // Handle mouse enter
  const handleMouseEnter = () => {
    setIconColor("black");
  };

  // Handle mouse leave
  const handleMouseLeave = () => {
    setIconColor("white");
  };
  return (
    <Box sx={style.BannerContainer}>
      <Box
        sx={{
          ...style.imgContainer,
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${Image})`,
        }}
      />
      <Box sx={style.overLayText}>
        <Typography sx={style.page}>{pageName}</Typography>
        <Typography sx={style.Quote}>{Quote}</Typography>
        <Typography>{description}</Typography>
        {watchFlimBtn && (
          <Button
            onClick={() => setOpen(true)}
            disableElevation
            disableRipple
            sx={{
              display: "flex",
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
              width: { xs: "154px", sm: "154px" },
              height: { xs: "36px", sm: "36px" },
              margin: "0 auto", // Ensures centering inside flex container
              border: "0.5px solid white",
              marginTop:"1%",
              background: "transparent",
              cursor: "pointer",
              position: "relative",
              overflow: "hidden",
              transition: "ease 0.3s",
              // Default text color (white)
              color: "white",
              "&::before": {
                content: '""',
                position: "absolute",
                height: "100%",
                width: "0%",
                top: 0,
                left: 0,
                backgroundColor: "white", // Fill color
                zIndex: 2,
                transition: "all 1s ease",
              },
              "&:hover": {
                color: "black", // Text color on hover
              },
              "&:hover::before": {
                width: "100%", // Fill from left to right on hover
              },
            }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            variant="outlined"
          >
            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontSize: { xs: "14px", sm: "12px" },
                position: "absolute",
                zIndex: 3,
                lineHeight: { xs: "", sm: "15.12px" },
                textTransform: "capitalize",
                letterSpacing: "0.05em",
              }}
            >
              <PlayArrowIcon sx={{ color: iconColor }} /> watch the Film
            </Typography>
          </Button>
        )}
      </Box>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        sx={{ backgroundColor: "rgba(128, 128, 128, 0.7)" }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "80%",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: "-50px",
              right: "10px",
              border: "1px solid #E1D9CF",
              backgroundColor: "transparent",
              borderRadius: "0",
            }}
          >
            <CloseIcon sx={{ fontSize: "16px", color: "#E1D9CF" }} />
          </IconButton>
          <video
            width="100%"
            height="100%"
            // controls
            autoPlay
            loop
            muted
            style={{ border: "none" }}
          >
            <source src={farmStoriesVideo} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </Box>
      </Modal>
    </Box>
  );
};

export default TopBannerSection;
